import {useAppContext} from "../../contexts";

function dataAdapter (
    legacy,
    newModel,
    mode
) {
    // Destructured props
    let {
        message,
        centered,
        rounded
    } = legacy;

    message ||=  newModel.message;
    centered =   (
        (typeof centered !== "undefined" || mode !== "new") ?
            centered :
            newModel.centered
    );
    rounded =    (
        (typeof rounded !== "undefined" || mode !== "new") ?
            rounded :
            newModel.rounded
    );

    return {
        message,
        centered: typeof centered !== "undefined" ? centered : true,
        rounded:  typeof rounded !== "undefined" ? rounded : true
    }
}

export const useErrorBadge = (
    rootProps,
    mode
) => {
    // A bridge to the new architecture model
    const {
        applicationAlerts
    } = useAppContext();

    return dataAdapter(
        rootProps,
        applicationAlerts["error"],
        mode
    );
}